module.exports = __webpack_public_path__ + "static/media/dollar.5499a819.svg";